module.exports = "/images/icon-pending.png?f876d9285e6476b948a95091863850dd";